"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDate = void 0;
const merge_1 = require("./util/merge");
const isNumeric_1 = require("./isNumeric");
const default_date_options = {
    format: 'YYYY/MM/DD',
    delimiters: ['/', '-'],
    strictMode: false,
};
function isValidFormat(format) {
    return /(^(y{4}|y{2})[\/-](m{1,2})[\/-](d{1,2})$)|(^(m{1,2})[\/-](d{1,2})[\/-]((y{4}|y{2})$))|(^(d{1,2})[\/-](m{1,2})[\/-]((y{4}|y{2})$))/gi.test(format);
}
function zip(date, format) {
    const zippedArr = [], len = Math.min(date.length, format.length);
    for (let i = 0; i < len; i++) {
        zippedArr.push([date[i], format[i]]);
    }
    return zippedArr;
}
function isDate(input, options = {}) {
    if (typeof options === 'string') { // Allow backward compatbility for old format isDate(input [, format])
        options = (0, merge_1.merge)({ format: options }, default_date_options);
    }
    else {
        options = (0, merge_1.merge)(options, default_date_options);
    }
    const _options = options;
    if (typeof input === 'string' && isValidFormat(_options.format)) {
        const formatDelimiter = _options.delimiters
            .find(delimiter => _options.format.indexOf(delimiter) !== -1);
        const dateDelimiter = _options.strictMode
            ? formatDelimiter
            : _options.delimiters.find(delimiter => input.indexOf(delimiter) !== -1);
        const dateAndFormat = zip(input.split(dateDelimiter), _options.format.toLowerCase().split(formatDelimiter));
        const dateObj = {};
        for (const [dateWord, formatWord] of dateAndFormat) {
            if (dateWord.length !== formatWord.length) {
                return false;
            }
            dateObj[formatWord.charAt(0)] = dateWord;
        }
        return new Date(`${dateObj['m']}/${dateObj['d']}/${dateObj['y']}`).getDate() === Number(dateObj['d']);
    }
    if (!options.strictMode) {
        return Object.prototype.toString.call(input) === '[object Date]' && (0, isNumeric_1.isNumeric)(input) && isFinite(input);
    }
    return false;
}
exports.isDate = isDate;
